import type { csmFolderSearchArticlesForSupportSiteQuery } from '@atlassian/csm-folder/src/ui/__generated__/csmFolderSearchArticlesForSupportSiteQuery.graphql';
import CsmFolderSearchQuery from '@atlassian/csm-folder/src/ui/__generated__/csmFolderSearchArticlesForSupportSiteQuery.graphql';
import { createRelayResource } from '@atlassian/help-center-common-util/resource-router/resource-router';

export const CsmFolderResource = createRelayResource<csmFolderSearchArticlesForSupportSiteQuery>({
    type: 'CSM_FOLDER',
    getQuery: ({ match }, { cloudId, helpCenterAri }) => {
        const pageId = match.params.folderId || '';
        return {
            parameters: CsmFolderSearchQuery,
            variables: {
                cloudId,
                helpCenterAri,
                first: 25,
                input: {
                    parentId: Number(pageId),
                },
            },
            options: {
                fetchPolicy: 'store-or-network',
            },
        };
    },
});
